import {
  Glass,
  Dot,
  ScreenLabel,
  DisplayText,
  BodyText,
  alpha,
  borderAlpha,
} from "../../components/mobile/primitives";

export function JourneyNextMorningScreen() {
  return (
    <div style={{ padding: "8px 16px 0", display: "flex", flexDirection: "column", gap: 9 }}>
      {/* Greeting */}
      <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <ScreenLabel>Mon, Mar 3</ScreenLabel>
        <DisplayText size={24}>Good morning</DisplayText>
        <DisplayText size={17} color="#3A4A3D">
          Sverre
        </DisplayText>
      </div>

      {/* Notification-style insight banner */}
      <div
        style={{
          background: "linear-gradient(135deg, rgba(165,144,255,0.10), rgba(91,122,102,0.08))",
          border: "1px solid rgba(165,144,255,0.18)",
          borderRadius: 16,
          padding: "10px 12px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
          <Dot color="var(--color-kin-lavender)" size={5} />
          <ScreenLabel>
            <span style={{ color: "var(--color-kin-lavender)" }}>Overnight Update</span>
          </ScreenLabel>
          <BodyText
            size={7}
            color="var(--color-kin-muted)"
            weight={500}
            style={{ marginLeft: "auto" }}
          >
            6:42 AM
          </BodyText>
        </div>
        <BodyText size={10} weight={600}>
          Sleep score 81 — best this week
        </BodyText>
        <BodyText size={8.5} color="var(--color-kin-muted)" weight={400} style={{ marginTop: 2 }}>
          Because you logged yesterday, Kin linked your afternoon dip to late caffeine timing.
        </BodyText>
      </div>

      {/* Tracker prompt — highlighted */}
      <div
        style={{
          background: "rgba(255,208,40,0.10)",
          border: "1px solid rgba(255,208,40,0.28)",
          borderRadius: 16,
          padding: "10px 12px",
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: 10,
            background: "rgba(255,208,40,0.16)",
            border: "1px solid rgba(255,208,40,0.32)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Dot color="var(--color-kin-gold)" size={10} />
        </div>
        <div style={{ flex: 1 }}>
          <BodyText size={10.5} weight={700}>
            Log breakfast
          </BodyText>
          <BodyText size={8} color="var(--color-kin-muted)" weight={400}>
            Day 2 of your diet + caffeine tracker
          </BodyText>
        </div>
        <div
          style={{
            background: "var(--color-kin-gold)",
            borderRadius: 20,
            padding: "5px 12px",
            flexShrink: 0,
          }}
        >
          <BodyText size={8} color="var(--color-kin-black)" weight={700}>
            Log
          </BodyText>
        </div>
      </div>

      {/* Skill update */}
      <Glass
        style={{
          padding: "9px 12px",
          background: "linear-gradient(150deg, rgba(165,144,255,0.08), rgba(255,255,255,0.50))",
          border: "1px solid rgba(165,144,255,0.16)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 3 }}>
          <Dot color="var(--color-kin-lavender)" size={5} />
          <ScreenLabel>
            <span style={{ color: "var(--color-kin-lavender)" }}>Sleep Deep Dive</span>
          </ScreenLabel>
        </div>
        <BodyText size={9} weight={500} style={{ lineHeight: 1.5 }}>
          New data from last night and yesterday's logs processed. Tap for an updated explanation.
        </BodyText>
      </Glass>

      {/* Trackers */}
      <div>
        <ScreenLabel style={{ marginBottom: 6, display: "block" }}>Today's Trackers</ScreenLabel>
        <Glass style={{ padding: "0 12px" }}>
          {[
            {
              color: "var(--color-kin-gold)",
              label: "Diet + Caffeine",
              status: "1 of 3",
              statusColor: "var(--color-kin-gold)",
            },
            {
              color: "var(--color-kin-lavender)",
              label: "Mood",
              status: "Log",
              statusColor: "var(--color-kin-lavender)",
            },
          ].map((t, i) => (
            <div
              key={t.label}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 9,
                padding: "7px 0",
                borderBottom: i === 0 ? "1px solid rgba(0,0,0,0.06)" : "none",
              }}
            >
              <Dot color={t.color} />
              <BodyText size={10} weight={600} style={{ flex: 1 }}>
                {t.label}
              </BodyText>
              <div
                style={{
                  background: alpha(t.statusColor, "1A"),
                  border: borderAlpha(t.statusColor, "40"),
                  borderRadius: 20,
                  padding: "2px 8px",
                }}
              >
                <BodyText size={7.5} color={t.statusColor} weight={700}>
                  {t.status}
                </BodyText>
              </div>
            </div>
          ))}
        </Glass>
      </div>
    </div>
  );
}
